import './ConfirmExportTicketModalView.scss';
export class ConfirmExportTicketModalController {
    static $inject = ['close', 'isTranscriptionExporting'];
    constructor(close, isTranscriptionExporting) {
        this.close = close;
        this.isTranscriptionExporting = isTranscriptionExporting;
    }
    closeModal() {
        this.close();
    }
}
ConfirmExportTicketModalController.$inject = ['close', 'isTranscriptionExporting'];
